import axios from "axios";
import * as actionTypes from "./actionTypes";
import { getPreviewPost } from "./PreviewAction";

//################ GET POST To EDIT :
export const initGetEditPost = () => {
  return {
    type: actionTypes.INIT_GET_EDIT_POST,
    loadinGetEditPost: true,
  };
};

export const successGetEditPost = (data) => {
  return {
    type: actionTypes.SUCCESS_GET_EDIT_POST,
    loadinGetEditPost: false,
    postToEdit: data,
  };
};

export const failGetEditPost = (error) => {
  return {
    type: actionTypes.FAIL_GET_EDIT_POST,
    loadinGetEditPost: false,
    error: error,
  };
};

export const getEditPost = (postId) => {
  return (dispatch) => {
    dispatch(initGetEditPost());
    axios
      .get(`all/lists/${postId}`)
      .then((response) => {
        dispatch(successGetEditPost(response.data));
      })
      .catch((error) => {
        console.log(error.message);
        dispatch(failGetEditPost(error.message));
      });
  };
};

//################ SAVE EDITED POST :
export const initPutEditPost = () => {
  return {
    type: actionTypes.INIT_PUT_EDIT_POST,
    loadingPutEdit: true,
  };
};

export const successPutEditPost = (data) => {
  return {
    type: actionTypes.SUCCESS_PUT_EDIT_POST,
    loadingPutEdit: false,
    EditedPost: data,
  };
};

export const failPutEditPost = (error) => {
  return {
    type: actionTypes.FAIL_PUT_EDIT_POST,
    loadingPutEdit: false,
    ErrorEditedPost: error,
  };
};

export const putEditPost = (vType, postId, data, media, vidMedia) => {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("idToken"),
    },
  };
  const configMedia = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("idToken"),
      "Content-Type": "multipart/form-data",
    },
  };
  if (!vidMedia) {
    return (dispatch) => {
      dispatch(initPutEditPost());
      axios
        .put(`${vType}/lists/${postId}`, data, config)
        .then((response) => {
          // dispatch(successPutEditPost(response.data));
          // dispatch(getPreviewPost(postId))
          if (media) {
            // const mediaLen = media.media.length;
            // let uploadedImgCounter = 0;
            let formData = new FormData();
            media.media.forEach((img, i) => {
              formData.append(`media[${+img.name - 1}][name]`, img.name);
              formData.append(`media[${+img.name - 1}][content]`, img.content);
            });
            axios
              .post(`${vType}/lists/${postId}`, formData, configMedia)
              .then((res) => {
                // console.log(res, i, mediaLen, uploadedImgCounter);
                // uploadedImgCounter++;
                dispatch(successPutEditPost(response.data));
                dispatch(getPreviewPost(postId));
                // if (uploadedImgCounter === mediaLen) {
                // }
              });
          } else {
            dispatch(successPutEditPost(response.data));
            dispatch(getPreviewPost(postId));
          }
        })
        .catch((error) => {
          dispatch(failPutEditPost(error.message));
        });
    };
  } else if (vidMedia) {
    return (dispatch) => {
      dispatch(initPutEditPost());
      axios
        .put(`${vType}/lists/${postId}`, data, config)
        .then((response) => {
          const responseData = response;
          let vidFormData = new FormData();
          vidFormData.append(`media[${0}][name]`, vidMedia.name);
          vidFormData.append(`media[${0}][content]`, vidMedia.content);
          vidFormData.append(`media[${0}][type]`, "mp4");
          axios
            .post(`${vType}/lists/${postId}`, vidFormData, configMedia)
            .then((response) => {
              // dispatch(successPutEditPost(responseData.data));
              // dispatch(getPreviewPost(postId))
              if (media) {
                // const mediaLen = media.media.length;
                // let uploadedImgCounter = 0;
                let formData = new FormData();
                media.media.forEach((img, i) => {
                  formData.append(`media[${+img.name - 1}][name]`, img.name);
                  formData.append(
                    `media[${+img.name - 1}][content]`,
                    img.content
                  );
                });
                axios
                  .post(`${vType}/lists/${postId}`, formData, configMedia)
                  .then((res) => {
                    // console.log(res, i, mediaLen, uploadedImgCounter);
                    // uploadedImgCounter++;
                    dispatch(successPutEditPost(responseData.data));
                    dispatch(getPreviewPost(postId));
                    // if (uploadedImgCounter === mediaLen) {
                    // }
                  });
              } else {
                dispatch(successPutEditPost(responseData.data));
                dispatch(getPreviewPost(postId));
              }
            })
            .catch((error) => {
              if (media) {
                const mediaLen = media.media.length;
                let uploadedImgCounter = 0;
                media.media.forEach((img, i) => {
                  let formData = new FormData();
                  formData.append(`media[${i}][name]`, img.name);
                  formData.append(`media[${i}][content]`, img.content);
                  axios
                    .post(`${vType}/lists/${postId}`, formData, configMedia)
                    .then((res) => {
                      uploadedImgCounter++;
                      if (uploadedImgCounter === mediaLen) {
                        dispatch(successPutEditPost(responseData.data));
                        dispatch(getPreviewPost(postId));
                      }
                    });
                });
              } else {
                dispatch(successPutEditPost(responseData.data));
                dispatch(getPreviewPost(postId));
              }
            });
        })
        .catch((error) => {
          dispatch(failPutEditPost(error.message));
        });
    };
  }
};
